<template>
  <div class="language-list">
    <profile-form
      ref="form"
      endpoint="local-mo"
      @error="$emit('done', $event)"
    >
      <form class="form">
        <fieldset style="padding: 0">
          <legend class="sr-only">
            {{accessibilityTitle}}
          </legend>
          <simple-list
            id="hotelList"
            ref="hotelList"
            :server-items="hotelOptions"
            class="req"
            variant="hotels-list"
            internal-scroll
            :height="listHeight"
          >
            <template #filter>
              <div
                ref="hotelListHeader"
                class="language-list-header"
              >
                <local-mo-list-search-bar
                  :search-placeholder="searchPlaceholder"
                  @filter-items="filterItems"
                />
              </div>
            </template>
            <template #card-template="{ item }">
              <local-mo-list-card
                :key="JSON.stringify(item)"
                :item="item"
                :search-input="inputString"
                :query-changed="queryChanged"
                :selected-hotel="selectedHotel"
                @destination-selected="updateFilter"
              />
            </template>
          </simple-list>
          <input
            type="hidden"
            :value="true"
            name="islocalMOPreferences"
          >
          <input
            type="hidden"
            :value="localProfile.localMOPreference"
            name="hotel"
          >
        </fieldset>
      </form>
    </profile-form>
    <loading-dots v-if="!hotelOptions && loading" />
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import ProfileInputMixin from '@mixins/profile-input-mixin'
  import { LocalMoListSearchBar, LocalMoListCard } from './components'

  export default {
    name: 'profile-local-mo-input',
    components: {
      LocalMoListSearchBar,
      LocalMoListCard
    },
    mixins: [ProfileInputMixin],
    props: {
      hotelOptions: {
        type: Array,
        required: true
      },
      searchPlaceholder: {
        type: String,
        default: 'Find your preferred Local MO'
      },
      accessibilityTitle: {
        type: String,
        default: 'Local MO Preference'
      },
    },
    data: () => ({
      listHeight: null,
      inputString: '',
      inputValue: { $exists: true },
      queryChanged: -1,
      localProfile: {
        localMOPreference: []
      },
      loading: true
    }),
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapState('booking', ['step']),
      ...mapState('responsive', { wHeight: 'height' }),
      selectedHotel() {
        return this.localProfile?.localMOPreference || { value: undefined }
      }
    },
    watch: {
      wHeight() {
        this.calculateListHeight()
      }
    },
    mounted() {
      this.calculateListHeight()
      this.configureModalStyle()
      this.loading = false
    },
    methods: {
      configureModalStyle() {
        const modalBody = document.querySelector('.modal-body')
        const modalFooter = document.querySelector('.modal-footer')
        modalBody.style.padding = 0
        modalFooter.style.display = 'none'
      },

      async updateFilter(data) {
        const myPreferences = this.localProfile.localMOPreference.map(i => i.value);

        this.localProfile.localMOPreference = await JSON.stringify({
          value: data.value,
          remove: myPreferences.indexOf(data.value) > -1
        });
      },
      calculateListHeight() {
        const headerHeight = this.$refs.hotelListHeader.clientHeight
        const modalHeaderHeight = document.querySelector('.modal-header').getBoundingClientRect().height
        this.listHeight = this.wHeight - headerHeight - modalHeaderHeight
      },
      async filterItems(value, type) {
        if (type === 'input') {
          if (value) {
            this.inputValue = { $regex: `${value}`, $options: 'i' }
            this.inputString = value
          } else {
            this.inputValue = { $exists: true }
            this.inputString = ''
          }
        }
        const searchFilter = {
          $and: [
            {
              propertyRegion: this.tabValue
            },
            {
              $or: [{ label: this.inputValue }]
            }
          ]
        }
        await this.$refs.hotelList.updateFilter(searchFilter)
        this.queryChanged += 1
      }
    }
  }
</script>
